import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Box, Card, CardContent, Grid, Accordion, AccordionSummary, AccordionDetails, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const testimonials = [
  {
    name: "Michael Thompson",
    feedback: "This service has made collecting payments so much easier. Highly recommended!"
  },
  {
    name: "Sarah Martinez",
    feedback: "A simple and effective tool to keep track of payments. It's a game changer!"
  },
  {
    name: "David Wilson",
    feedback: "I no longer have to remind people manually. This app does it all for me!"
  }
];

const faqs = [
  {
    question: "How does this service work?",
    answer: "Our platform allows you to schedule automated payment reminders via email to recipients of your choice. You can customize the frequency and content of reminders."
  },
  {
    question: "Is this service free?",
    answer: "Yes, our service is currently free with some limitations. Additional features may be introduced in the future."
  },
  {
    question: "What happens if a recipient does not pay?",
    answer: "Our platform only facilitates sending reminders. We do not guarantee payments from recipients."
  },
  {
    question: "Can I track the status of reminders?",
    answer: "Yes, you can monitor sent reminders and check their delivery status from your dashboard."
  }
];

const supportedServices = [
  {
    alt: "PayPal",
    source: process.env.PUBLIC_URL + "/paypal.png"
  },
  // {
  //   alt: "Zelle",
  //   source: process.env.PUBLIC_URL + "/zelle.png"
  // },
  {
    alt: "Venmo",
    source: process.env.PUBLIC_URL + "/venmo.png"
  },
  {
    alt: "Cash App",
    source: process.env.PUBLIC_URL + "/cashapp.png"
  },
];

function Home() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/getting-started');
  };
  
  return (
    <Container maxWidth="md" sx={{ textAlign: "center", padding: 4, '& *': {fontFamily: '"Tinos", cursive !important'} }}>
      <Typography variant="h4" gutterBottom>
        Collecting Cash Made Easy
      </Typography>
      <Typography variant="h6" color="textSecondary" paragraph sx={{ marginTop: 6 }}>
        Simplify your payment collections with automated reminders.
        Keep track of recurring payments effortlessly and ensure you never miss a due payment.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, marginTop: 3 }}>
        <Button variant="contained" color="primary" size="large" onClick={handleClick}>
          Get Started
        </Button>
      </Box>
      
      <Typography variant="h5" sx={{ marginTop: 6 }}>What Our Users Say</Typography>
      <Grid container spacing={3} sx={{ marginTop: 2 }}>
        {testimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Card>
              <CardContent>
                <Typography variant="body1">"{testimonial.feedback}"</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      
      <Typography variant="h5" sx={{ marginTop: 6 }}>More About Our Service</Typography>
      <Typography variant="body1" color="textSecondary" paragraph sx={{ marginTop: 2 }}>
        Our web application helps you automate the process of collecting payments by sending timely reminders to recipients.
        Whether you're managing monthly subscriptions, shared expenses, or business invoices, our platform ensures that no payment goes unnoticed.
        You can customize your reminders, track responses, and even explore additional payment collection methods in the future.
        With a simple and intuitive interface, we make it easy for you to stay organized and stress-free.
      </Typography>
      
      <Typography variant="h4" sx={{ marginTop: 6 }}>Supported Payment Methods</Typography>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 3, marginTop: 2 }}>
        <Stack  spacing={{ xs: 1, sm: 2 }}  direction="row"  useFlexGap  sx={{ flexWrap: 'wrap', justifyContent: "center" }}>
        <Stack  spacing={{ xs: 1, sm: 2 }}  direction="row"  useFlexGap  sx={{ flexWrap: 'wrap' }}>
          <img src={process.env.PUBLIC_URL + "/paypal.png"} width={80} style={{backgroundColor: "white", borderRadius: "15px", padding: "4px"}} alt="PayPal" />
          <img src={process.env.PUBLIC_URL + "/venmo.png"} width={80} style={{borderRadius: "15px"}} alt="Venmo" />
        </Stack>
        <Stack  spacing={{ xs: 1, sm: 2 }}  direction="row"  useFlexGap  sx={{ flexWrap: 'wrap' }}>
          <img src={process.env.PUBLIC_URL + "/cashapp.png"} width={80} style={{borderRadius: "15px"}} alt="Cash App" />
          {/* <img src={process.env.PUBLIC_URL + "/zelle.png"} width={80} style={{borderRadius: "15px"}} /> */}
        </Stack>
        </Stack>
      </Box>
      
      <Typography variant="h4" sx={{ marginTop: 6 }}>Frequently Asked Questions</Typography>
      <Box sx={{ marginTop: 2 }}>
        {faqs.map((faq, index) => (
          <Accordion key={index}>
            <AccordionSummary expandIcon={<ExpandMoreIcon aria-hidden="true" />}>
              <Typography variant="h6">{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>);
}
export default Home;